// PO1-3484: textos do chat do Autopilot para o "Montar e-mail para a transportadora".
// O e-mail em si vem pronto do backend (POST /transportadoras/:id/integracao/email-autopilot),
// que classifica cada campo vazio da aba Configuração e confere a resposta da LLM.

// Pergunta que aparece no chat como se o usuário tivesse feito.
export function perguntaVisivel(transportadora) {
  const nome = transportadora && transportadora.nome;
  return `Monte o e-mail para eu pedir ${nome ? `à ${nome}` : "à transportadora"} os dados da integração de cotação pela API.`;
}

// Contexto que vai junto com o primeiro pedido de ajuste no chat: o e-mail foi montado
// fora do chat (rota de e-mail do gateway) e o Autopilot do chat não o conhece.
export function contextoAjusteEmail(transportadora, textoEmail) {
  const nome = (transportadora && transportadora.nome) || "a transportadora";
  return [
    `Contexto: você montou o rascunho abaixo para eu enviar à ${nome}, pedindo os dados da integração de cotação pela API no Everlog Hub.`,
    "Ajuste conforme o meu pedido e devolva o e-mail completo (assunto e corpo), mantendo o que eu não pedi para mudar.",
    "Mantenha separada a parte \"Para você preencher na tela\". Não inclua senha, token ou chave.",
    "",
    textoEmail,
  ].join("\n");
}

// Resposta quando não há nada a pedir à transportadora (todos os campos preenchidos).
export function textoSemPendencias(paraVoce) {
  const linhas = ["Todos os dados que a transportadora fornece já estão preenchidos. Não há o que pedir por e-mail."];
  if (paraVoce && paraVoce.length) {
    linhas.push("", "**Falta você:**");
    paraVoce.forEach((p) => linhas.push(`- **${p.campo}**: ${p.texto}`));
  }
  return linhas.join("\n");
}
